"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PenaltyTypeEnum = void 0;
var PenaltyTypeEnum;
(function (PenaltyTypeEnum) {
    PenaltyTypeEnum["BALL_ABUSE"] = "BALL_ABUSE";
    PenaltyTypeEnum["COACHING"] = "COACHING";
    PenaltyTypeEnum["DRESS_CODE_VIOLATION"] = "DRESS_CODE_VIOLATION";
    PenaltyTypeEnum["EQUIMENT_VIOLATION"] = "EQUIMENT_VIOLATION";
    PenaltyTypeEnum["FAILUIRE_TO_SIGN_IN"] = "FAILUIRE_TO_SIGN_IN";
    PenaltyTypeEnum["FAILURE_TO_COMPLETE"] = "FAILURE_TO_COMPLETE";
    PenaltyTypeEnum["INELIGIBILITY"] = "INELIGIBILITY";
    PenaltyTypeEnum["LEAVING_THE_COURT"] = "LEAVING_THE_COURT";
    PenaltyTypeEnum["NO_SHOW"] = "NO_SHOW";
    PenaltyTypeEnum["PHYSICAL_ABUSE"] = "PHYSICAL_ABUSE";
    PenaltyTypeEnum["PROHIBITED_SUBSTANCE"] = "PROHIBITED_SUBSTANCE";
    PenaltyTypeEnum["PUNCTUALITY"] = "PUNCTUALITY";
    PenaltyTypeEnum["RACKET_ABUSE"] = "RACKET_ABUSE";
    PenaltyTypeEnum["REFUSAL_TO_PLAY"] = "REFUSAL_TO_PLAY";
    PenaltyTypeEnum["UNSPORTSMANLIKE_CONDUCT"] = "UNSPORTSMANLIKE_CONDUCT";
    PenaltyTypeEnum["VERBAL_ABUSE"] = "VERBAL_ABUSE";
    PenaltyTypeEnum["OTHER"] = "OTHER";
})(PenaltyTypeEnum || (exports.PenaltyTypeEnum = PenaltyTypeEnum = {}));
//# sourceMappingURL=penalty_type.js.map